<template>
	<div :class="isProject ? 'custom-editor' : ' custom-editor-d'">
		<!-- <div>
			<el-upload :action="defaultSettings.systemLinkApi + 'enterprise/tracking/uploadFile/file'"
				:before-upload="handleBeforeUpload" :on-success="handleUploadSuccess" :on-error="handleUploadError"
				name="file" :show-file-list="false" :data="uploadData" :headers="uploadData" class="editor-img-uploader"
				v-if="type == 'url'">
				<i ref="uploadRef" class="editor-img-uploader"></i>
			</el-upload>
		</div> -->
		<!-- <div class="editor">
			<quill-editor ref="quillEditorRef" :content="content" contentType="html" @textChange="tc"
				@click.native="getFocus" :options="options" :style="styles" />
		</div> -->

		<!-- 20250509 新增富文本相关开始 -->
		<Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" class="borderBottom" />
		<Editor v-model="content" id="editor" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"
			@onChange="handleChange" @onDestroyed="handleDestroyed" @onFocus="handleFocus" @onBlur="handleBlur"
			class="editorContent" />
		<!-- 20250509 新增富文本相关结束 -->
	</div>
</template>

<script setup>
	// 20250509 新增富文本相关开始
	import '@wangeditor/editor/dist/css/style.css' // 引入 css
	import {
		onBeforeUnmount,
		ref,
		shallowRef,
		computed,
		onMounted,
		nextTick,
		defineExpose
	} from 'vue'
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	import {
		DomEditor,
		SlateEditor
	} from '@wangeditor/editor'
	// 20250509 新增富文本相关结束

	// import {
	// 	QuillEditor
	// } from '@vueup/vue-quill'
	// import '@vueup/vue-quill/dist/vue-quill.snow.css'
	import useUserStore from '@/store/modules/user.js'
	// import { getToken } from '@/utils/auth'
	// import defaultSettings from '@/settings'

	const emit = defineEmits()
	const {
		proxy
	} = getCurrentInstance()

	const quillEditorRef = ref()
	// const uploadUrl = ref(import.meta.env.VITE_APP_BASE_API + "/common/upload"); // 上传的图片服务器地址
	// const headers = ref({ Authorization: 'Bearer ' + getToken() })
	// const uploadData = ref({})

	const props = defineProps({
		/* 编辑器的内容 */
		modelValue: {
			type: String,
		},
		/* 高度 */
		height: {
			type: Number,
			default: null,
		},
		/* 最小高度 */
		minHeight: {
			type: Number,
			default: null,
		},
		/* 只读 */
		readOnly: {
			type: Boolean,
			default: false,
		},
		/* 上传文件大小限制(MB) */
		fileSize: {
			type: Number,
			default: 5,
		},
		/* 类型（base64格式、url格式） */
		type: {
			type: String,
			default: 'url',
		},
		obj: {
			type: Object,
			default: () => {},
		},
		placeholder: {
			type: String,
			default: '',
		},
		isAutoFocus: {
			type: Boolean,
			default: true,
		},
		defaultFontSize: {
			type: String,
			default: '',
		}
	})

	// 20250509 新增富文本相关开始
	// 编辑器实例，必须用 shallowRef
	const editorRef = shallowRef()

	// 内容 HTML
	// const valueHtml = ref('<p>hello</p>')
	const toolbarConfig = {
		toolbarKeys: [
			// 'headerSelect',
			// 菜单 key
			'bold',
			'italic',
			'underline',
			'through',
			'clearStyle',
			'|', // 分割线
			'color',
			'|',
			'bgColor',
			'|',
			'fontSize',
			'|',
			// 'fontFamily',
			'indent',
			'delIndent',
			'justifyLeft',
			'justifyRight',
			'justifyCenter',
			'justifyJustify',
			// '|',
			// 'lineHeight',
			// '|',
			'redo',
			'undo',
			// 菜单组，包含多个菜单
			// {
			// 	key: 'group-more-style', // 必填，要以 group 开头
			// 	title: '更多样式', // 必填
			// 	iconSvg: '<svg>....</svg>', // 可选
			// 	menuKeys: ['through', 'code', 'clearStyle'], // 下级菜单 key ，必填
			// },
			// 继续配置其他菜单...
		]
	}
	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	const projectConfigData = computed(() => {
		return useUserStore().projectConfigData
	})
	const autoFocus = computed(() => {
		return props.isAutoFocus
	})

	// 项目中心（项目/模块/需求）--编辑时会传创建时的默认字号值
	const defaultFontSizeVal = computed(() => {
		return props.defaultFontSize
	})
	const editorConfig = ref({
		placeholder: props.placeholder || '请输入内容',
		autoFocus: autoFocus.value
		// 20260402 新增 关键配置：false禁止自动聚焦 true自动聚焦（档案-追加 公告/通告-编辑）（false项目追踪-项目介绍/模块详情 档案-新建/编辑）
	})

	// 是否是项目中心
	const isProject = computed(() => {
		return props.placeholder.includes('介绍') || props.placeholder.includes('项目描述')
	})

	// 项目--编辑时默认字号取创建时的默认字号值 创建时取项目配置部分的字号值
	const defaultFontSize = computed(() => {
		let size = '13px' // 非项目时默认值

		if (isProject.value) {
			size = defaultFontSizeVal.value || projectConfigData.value.fontSize
		}

		return size
	});

	// 根据主题色 设置富文本默认字体颜色
	watch(theme, val => {
		console.log('val theme', val)
		if (val === 'dark') {
			document.documentElement.style.setProperty('--w-e-toolbar-color', '#B9B9B9');
			document.documentElement.style.setProperty('--w-e-textarea-color', '#FFFFFF');
			document.documentElement.style.setProperty('--w-e-toolbar-bg-color', '#262626');
			document.documentElement.style.setProperty('--w-e-toolbar-active-color', '#B9B9B9');
			document.documentElement.style.setProperty('--w-e-toolbar-border-color', '#343737');
			document.documentElement.style.setProperty('--w-e-toolbar-disabled-color', '#4b4b4b');
			document.documentElement.style.setProperty('--w-e-textarea-slight-color', '#B9B9B9');
			document.documentElement.style.setProperty('--w-e-toolbar-active-bg-color', '#3B3B3B');
			document.documentElement.style.setProperty('--w-e-textarea-bg-color', 'rgba(255, 255, 255, 0.05)');
		} else {
			document.documentElement.style.removeProperty('--w-e-toolbar-color');
			document.documentElement.style.removeProperty('--w-e-textarea-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-bg-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-active-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-border-color');
			document.documentElement.style.setProperty('--w-e-toolbar-disabled-color', '#C4C4C4');
			document.documentElement.style.setProperty('--w-e-textarea-slight-color', 'rgba(0, 0, 0, 0.6)');
			document.documentElement.style.removeProperty('--w-e-toolbar-active-bg-color');
			document.documentElement.style.removeProperty('--w-e-textarea-bg-color');
		}
	}, {
		immediate: true
	})

	const handleCreated = (editor) => {
		console.log(editor, defaultFontSize.value, defaultFontSizeVal.value, projectConfigData.value.fontSize,
			'handleCreated editor defaultFontSize, defaultFontSizeVal.value, projectConfigData.value.fontSize')

		editorRef.value = editor // 记录 editor 实例，重要！

		// 项目中心时（项目介绍/模块/需求详情） 20260916 新增优化
		if (isProject.value) {
			// 处理默认字号问题
			defaultFontSizeHandle(editor, defaultFontSize.value)
		} else {
			// 站内信--发布 公告--发布/编辑 通告--发布/编辑 材料（新增/编辑）--凭证描述
			const editableContainer = editor.getEditableContainer?.();
			editableContainer.style.setProperty('font-size', '13px');
		}


		// console.log(content.value, editor.getConfig(), 'content.value 获取配置')
		// console.log(projectConfigData.value.fontSize, 'projectConfigData.value.fontSize')
		// 默认为13px 20260512 只有项目部分动态更改
		// if (props.placeholder.includes('介绍') || props.placeholder.includes('项目描述')) {
		// 	// 20260901新增优化
		// 	document.documentElement.style.removeProperty('--default-font-size');

		// 	console.log(props.placeholder.includes('介绍'), props.placeholder.includes('项目描述'),
		// 		'介绍/项目描述 defaultFontSize', defaultFontSize.value, defaultFontSizeVal.value, projectConfigData.value
		// 		.fontSize)

		// 	const editableContainer = editor.getEditableContainer?.();
		// 	if (editableContainer) {
		// 		console.log('editableContainer defaultFontSize', defaultFontSize.value, defaultFontSizeVal.value,
		// 			projectConfigData.value.fontSize)
		// 		// 默认为13px
		// 		// 20260916 新增优化 处理默认字号问题
		// 		defaultFontSizeHandle(editor, defaultFontSize.value)

		// 		// editableContainer.style.setProperty('font-size', defaultFontSize.value + 'px');
		// 		// 20260610 新增样式优化 避免影响全局  20260915新增注释
		// 		// editableContainer.style.setProperty('font-size', defaultFontSize.value, 'important');
		// 		// 20260610 新增注释
		// 		// document.documentElement.style.setProperty('font-size', defaultFontSize, 'important')
		// 		// editableContainer.style.cssText += `; font-size: ${defaultFontSize} !important;`;
		// 	} else {
		// 		console.log('!editableContainer defaultFontSize', defaultFontSize.value, defaultFontSizeVal.value,
		// 			projectConfigData.value.fontSize)
		// 	}
		// } else {
		// 	// 20260916 新增优化 处理默认字号问题
		// 	defaultFontSizeHandle(editor, defaultFontSize.value)
		// 	console.log('!介绍/项目描述 defaultFontSize13')
		// 	// 20260915新增优化
		// 	// editableContainer.style.setProperty('font-size', '13px');
		// 	// document.documentElement.style.setProperty('--default-font-size', '13px')
		// }

		// 获取编辑器的可编辑区域 DOM 元素
		proxy.$nextTick(() => {
			const editableElem = document.querySelector('.w-e-text-container');
			if (editableElem) {
				editableElem.addEventListener('keydown', keyDown, true);
			}
		});

		// 绑定监听事件 20260212注释
		// window.addEventListener('keydown', keyDown)
	}

	// 20260916 新增 
	function defaultFontSizeHandle(editor, defaultSizeStr) {
		// 1.默认字号落 mark，使 span 生成内联样式，效果与显式选择字号一致
		const rawInsertText = editor.insertText.bind(editor)
		editor.insertText = (text, props) => {
			const marks = SlateEditor.marks(editor) || {}
			if (!marks.fontSize) {
				// 未显式选择字号时，补充默认字号 mark
				editor.marks = {
					...marks,
					fontSize: defaultSizeStr
				}
			}
			rawInsertText(text, props)
		}

		// 2. 字号等于默认值时，下拉仍显示"默认"文案
		nextTick(() => {
			const toolbar = DomEditor.getToolbar(editor)
			// const curToolbarConfig = toolbar.getConfig()
			// console.log(curToolbarConfig.toolbarKeys) // 当前菜单排序和分组

			const fontSizeMenu = toolbar && toolbar.getMenus ? toolbar.getMenus().fontSize : null
			if (fontSizeMenu) {
				const rawGetValue = fontSizeMenu.getValue.bind(fontSizeMenu)
				fontSizeMenu.getValue = (ed) => {
					const val = rawGetValue(ed)
					// 当前字号等于默认字号时返回空串，下拉显示"默认"
					return val === defaultSizeStr ? '' : val
				}
			}
		})
	}

	const handleChange = (editor) => {
		console.log(editor, 'editor handleChange')
	}

	const handleDestroyed = (editor) => {
		console.log(editor, 'editor handleDestroyed')
	}

	const handleFocus = (editor) => {
		proxy.$emit('focusHandle')
		console.log(editor, 'editor handleFocus')
	}

	const handleBlur = (editor) => {
		console.log(editor, 'editor handleBlur')
	}
	// 20250509 新增富文本相关结束

	// // 自动/点击获取焦点方法
	// const getFocus = () => {
	// 	// 通过refs访问Quill编辑器实例
	// 	const quillEditor = quillEditorRef.value.getQuill();
	// 	// 使用Quill的focus方法获取焦点
	// 	quillEditor.focus();
	// 	document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
	// }

	// ***这里需要暴露出去不然父组件调用不到这个方法
	defineExpose({
		// getFocus,
		commonFocus
	})

	// tab获取焦点
	function commonFocus(type) {
		// 20260515 新增 type => 项目介绍project 模块需求详情moduleAndRequire 材料编辑materialsEdit 新增/追加材料memberArchiveNewMaterials
		//（区分：从标题处tab切换还是文本处切换）
		// true焦点移到内容末尾 false焦点在内容开头
		editorRef.value.focus(type ? true : false); // 将焦点设置到编辑器，第二个参数为false表示不触发selectionchange事件
	}

	// function tc(cs) {
	// 	emit('update:modelValue', quillEditorRef.value.getContents())
	// }

	// const options = ref({
	// 	theme: 'snow',
	// 	bounds: document.body,
	// 	debug: 'warn',
	// 	modules: {
	// 		// 工具栏配置
	// 		toolbar: [
	// 			["clean"], // 清除文本格式
	// 			[{
	// 				size: ['small', false, 'large', 'huge']
	// 			}], // 字体大小
	// 			['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
	// 			// ["blockquote", "code-block"], // 引用  代码块
	// 			// [{ indent: "-1" }, { indent: "+1" }], // 缩进
	// 			// [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
	// 			[{
	// 				color: []
	// 			}, {
	// 				background: []
	// 			}], // 字体颜色、字体背景颜色
	// 			[{
	// 				list: 'ordered'
	// 			}, {
	// 				list: 'bullet'
	// 			}], // 有序、无序列表
	// 			// [{
	// 			// 	align: []
	// 			// }], // 对齐方式
	// 			// ['image'] // ["link", "image", "video"] 链接、图片、视频
	// 		],
	// 	},
	// 	placeholder: props.placeholder || '请输入内容',
	// 	readOnly: props.readOnly
	// })

	// const styles = computed(() => {
	// 	let style = {}
	// 	if (props.minHeight) {
	// 		style.minHeight = `${props.minHeight}px`
	// 	}
	// 	if (props.height) {
	// 		style.height = `${props.height}px`
	// 	}
	// 	return style
	// })

	watch(props.obj, val => {
		console.log('val', val)
		if (typeof val === 'undefined') {
			return
		}
		// if (JSON.stringify(val) !== '{}') {
		// 	uploadData.value = {
		// 		type: val.type === 2 ? 'requirement' : 'module',
		// 		onlyId: (val.type === 2 ? val.requirementId : val.moduleId) || 0,
		// 		uuid: Date.now(),
		// 		token: localStorage.getItem('token')
		// 	}
		// }
		// console.log(uploadData.value, 'uploadData.value')
	}, {
		immediate: true
	})

	const content = ref('')
	watch(() => props.modelValue, v => {
		// console.log(v !== content.value, 'v !== content.value', v, content.value)
		if (v !== content.value) {
			content.value = (v === undefined || v === '') ? '' : v
		}
	}, {
		immediate: true
	})

	// content
	watch(content, val => {
		console.log('val content', val)
		emit('update:modelValue', val)
	}, {
		immediate: true
	})

	// 如果设置了上传地址则自定义图片上传事件
	onMounted(() => {
		// if (props.type === 'url') {
		// 	let quill = quillEditorRef.value.getQuill()
		// 	let toolbar = quill.getModule('toolbar')
		// 	toolbar.addHandler('image', value => {
		// 		if (value) {
		// 			proxy.$refs.uploadRef.click()
		// 		} else {
		// 			quill.format('image', false)
		// 		}
		// 	})
		// }

		// 获取项目默认配置 20260609 新增注释 防止字号加载慢影响渲染
		// useUserStore().configprojecttrackingInfoApi()
		// 绑定监听事件
		// window.addEventListener('keydown', keyDown, true)

		// // 20250509 新增富文本相关
		// setTimeout(() => {
		// 	valueHtml.value = '<p>模拟 Ajax 异步设置内容</p>'
		// }, 1500)
	})

	// 20250509 新增富文本相关
	// 组件销毁时，也及时销毁编辑器
	onBeforeUnmount(() => {
		// // 恢复原始值
		// // document.documentElement.style.removeProperty(key)
		// document.documentElement.style.removeProperty('--w-e-toolbar-color');
		// document.documentElement.style.removeProperty('--w-e-textarea-color');
		// document.documentElement.style.removeProperty('--w-e-toolbar-bg-color');
		// document.documentElement.style.removeProperty('--w-e-toolbar-active-color');
		// document.documentElement.style.removeProperty('--w-e-toolbar-border-color');
		// document.documentElement.style.removeProperty('--w-e-textarea-slight-color');
		// document.documentElement.style.removeProperty('--w-e-toolbar-active-bg-color');
		// document.documentElement.style.removeProperty('--w-e-textarea-bg-color');

		// const editor = editorRef.value
		// if (editor == null) return
		// editor.destroy()
	})

	onUnmounted(() => {
		// 20260312 新增组件销毁优化
		setTimeout(() => {
			// 恢复原始值
			// document.documentElement.style.removeProperty(key)
			document.documentElement.style.removeProperty('--w-e-toolbar-color');
			document.documentElement.style.removeProperty('--w-e-textarea-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-bg-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-active-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-border-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-disabled-color');
			document.documentElement.style.removeProperty('--w-e-textarea-slight-color');
			document.documentElement.style.removeProperty('--w-e-toolbar-active-bg-color');
			document.documentElement.style.removeProperty('--w-e-textarea-bg-color');

			// 20260610新增优化
			// document.documentElement.style.removeProperty('--default-font-size');

			const editor = editorRef.value
			if (editor == null) return
			editor.destroy()
		})

		window.removeEventListener('keydown', keyDown, true)
	})

	function keyDown(e) {
		console.log(e, 'e keyDown document.activeElement Editor', document.activeElement, useUserStore().isModal)

		// 弹窗显示 键盘快捷键强制失效
		if (useUserStore().isModal) {
			return
		}

		// 内容为空时 tab不支持缩进
		if (e.key === 'Tab') {
			// 20260427 修改 恢复正常tab功能
			// // 富文本禁用tab快捷键
			// e.preventDefault()
			// if (content.value === '<p> &nbsp; &nbsp;</p>') {
			// 	// console.log(content.value, 'content.valuecontent.valuecontent.value')
			// 	content.value = ''
			// }

			// tab加日志
			console.log(e, 'e keyDown Tab document.activeElement', document.activeElement)
		} else if (e.ctrlKey && e.key === 'Enter') {
			// CapsLock(tab下方按键) 开启+enter e.getModifierState('CapsLock') => ctrl+enter
			e.preventDefault()
			if (content.value === '<p> &nbsp; &nbsp;</p>') {
				// console.log(content.value, 'content.valuecontent.valuecontent.value')
				content.value = ''
			}
			return
		} else if (e.key === 'Enter' && !e.shiftKey) {
			console.log('Enter !e.shiftKey  让事件自然传播')
			return // 让事件自然传播
			// 确保默认行为不被外部干扰
			// e.stopPropagation() // 阻止事件传播到外部全局监听器
			// 不需要 e.preventDefault()，让编辑器自行处理换行
		}
	}

	// 上传前校检格式和大小
	function handleBeforeUpload(file) {
		const type = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg']
		const isJPG = type.includes(file.type)
		//检验文件格式
		if (!isJPG) {
			proxy.$modal.msgError('图片格式错误!')
			return false
		}
		// // 校检文件大小
		// if (props.fileSize) {
		// 	const isLt = file.size / 1024 / 1024 < props.fileSize;
		// 	if (!isLt) {
		// 		proxy.$modal.msgError(`上传文件大小不能超过 ${props.fileSize} MB!`);
		// 		return false;
		// 	}
		// }
		return true
	}

	// 上传成功处理
	function handleUploadSuccess(res, file) {
		let url = res.data.enterpriseTrackingFileNameBean.url

		// 如果上传成功
		if (res.code === 200) {
			// 获取富文本实例
			let quill = toRaw(quillEditorRef.value).getQuill()
			// 获取光标位置
			let length = quill.selection.savedRange.index
			// 插入图片，res.url为服务器返回的图片链接地址
			quill.insertEmbed(length, 'image', url)
			// quill.insertEmbed(length, "image", import.meta.env.VITE_APP_BASE_API + res.fileName);
			// 调整光标到最后
			quill.setSelection(length + 1)
		} else {
			proxy.$modal.msgError('图片插入失败')
		}
	}

	// 上传失败处理
	function handleUploadError() {
		proxy.$modal.msgError('图片插入失败')
	}
</script>

<style>
	.editor-img-uploader {
		display: none;
	}

	.editor,
	.ql-toolbar {
		white-space: pre-wrap !important;
		line-height: normal !important;
	}

	.quill-img {
		display: none;
	}

	.ql-snow .ql-tooltip[data-mode="link"]::before {
		content: "请输入链接地址:";
	}

	.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
		border-right: 0px;
		content: "保存";
		padding-right: 0px;
	}

	.ql-snow .ql-tooltip[data-mode="video"]::before {
		content: "请输入视频地址:";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item::before {
		content: "14px";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
		content: "10px";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
		content: "18px";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
		content: "32px";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item::before {
		content: "文本";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
		content: "标题1";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
		content: "标题2";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
		content: "标题3";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
		content: "标题4";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
		content: "标题5";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
		content: "标题6";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item::before {
		content: "标准字体";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
		content: "衬线字体";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
		content: "等宽字体";
	}

	/* 设置编辑器默认字号 */
	/* .custom-editor .w-e-text-container p {
		font-size: var(--default-font-size) !important;
	} */

	/* 优化：内层嵌套 span 统一继承段落行高，屏蔽 span 上内联/级联的多层行高差异 */
	/* .custom-editor .w-e-text-container p {
		font-size: inherit !important;
	} */

	.custom-editor-d .w-e-text-placeholder {
		font-size: 13px;
	}

	.custom-editor-d .w-e-text-container p {
		font-size: var(--default-font-size) !important;
	}
</style>